import { Link, useNavigate } from "react-router-dom";
import { useCart } from "../context/CartContext";
import { Trash2, ArrowRight } from "lucide-react";

export default function Cart() {
  const { items, updateQty, removeItem, total } = useCart();
  const navigate = useNavigate();

  if (items.length === 0) {
    return (
      <div className="max-w-3xl mx-auto px-5 py-24 text-center" data-testid="cart-empty">
        <h1 className="font-heading text-4xl font-900 uppercase tracking-tight">Your Cart Is Empty</h1>
        <p className="text-[#A1A1AA] mt-3">Time to gear up and run your race.</p>
        <Link to="/shop" className="inline-block mt-8 bg-[#E63946] hover:bg-[#FF4D5A] text-white font-semibold uppercase tracking-wider text-sm px-8 py-4 transition-colors">
          Shop Now
        </Link>
      </div>
    );
  }

  return (
    <div className="max-w-5xl mx-auto px-5 sm:px-8 py-12">
      <h1 className="font-heading text-5xl font-900 uppercase tracking-tight mb-10">Your Cart</h1>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        <div className="lg:col-span-2 space-y-4">
          {items.map((i) => (
            <div key={i.key} data-testid={`cart-item-${i.product_id}`}
              className="flex gap-4 bg-[#121212] border border-white/10 p-4">
              <img src={i.image} alt={i.name} className="w-24 h-24 object-cover bg-[#1A1A1A]" />
              <div className="flex-1">
                <h3 className="font-heading text-lg font-700 uppercase tracking-tight">{i.name}</h3>
                {i.size && <p className="text-xs text-[#A1A1AA] mt-1">Size: {i.size}</p>}
                <p className="text-[#E63946] font-semibold mt-1">${i.price.toFixed(2)}</p>
                <div className="flex items-center gap-3 mt-3">
                  <div className="flex items-center border border-white/20">
                    <button onClick={() => updateQty(i.key, i.quantity - 1)} className="w-8 h-8 hover:bg-white/10 transition-colors">−</button>
                    <span className="w-8 text-center text-sm">{i.quantity}</span>
                    <button onClick={() => updateQty(i.key, i.quantity + 1)} className="w-8 h-8 hover:bg-white/10 transition-colors">+</button>
                  </div>
                  <button onClick={() => removeItem(i.key)} data-testid={`remove-${i.product_id}`} className="text-[#A1A1AA] hover:text-[#E63946] transition-colors">
                    <Trash2 size={18} />
                  </button>
                </div>
              </div>
              <div className="text-right font-heading font-700 text-lg">${(i.price * i.quantity).toFixed(2)}</div>
            </div>
          ))}
        </div>
        <div className="bg-[#121212] border border-white/10 p-6 h-fit">
          <h3 className="font-heading text-xl font-700 uppercase tracking-tight mb-4">Summary</h3>
          <div className="flex justify-between text-sm text-[#A1A1AA] mb-2">
            <span>Subtotal</span><span data-testid="cart-subtotal">${total.toFixed(2)}</span>
          </div>
          <div className="flex justify-between text-sm text-[#A1A1AA] mb-4">
            <span>Shipping</span><span>Calculated at checkout</span>
          </div>
          <div className="border-t border-white/10 pt-4 flex justify-between font-heading font-800 text-xl">
            <span>Total</span><span data-testid="cart-total">${total.toFixed(2)}</span>
          </div>
          <button onClick={() => navigate("/checkout")} data-testid="checkout-btn"
            className="mt-6 w-full bg-[#E63946] hover:bg-[#FF4D5A] text-white font-semibold uppercase tracking-wider text-sm px-6 py-4 flex items-center justify-center gap-2 transition-colors">
            Checkout <ArrowRight size={16} />
          </button>
        </div>
      </div>
    </div>
  );
}
